export default __webpack_public_path__ + "static/caseyjones-8aacf6de4740fe16cc5f64e38656f210.png";